<app-header *ngIf="showHeaderFlag && (true | loginStatus)"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="showHeaderFlag && (true | loginStatus) && showFooterFlag"></app-footer>
<app-loader></app-loader>
<app-design-loader *ngIf="!hideDesignLoader" [progress]="percentage"
    [fromEvent]="eventName"></app-design-loader>
<app-duplicate-tab-error></app-duplicate-tab-error>

